import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import ContactListItem from './contact-list-item.gjs';
import MessagingPage from './messaging-page.gjs';
import styles from './contacts-page.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class ContactsPage extends Component {
  @service messaging;

  @action
  leaveContactPage() {
    this.messaging.contactPageActive = false;
  }

  <template>
    <MessagingPage class="{{styles.component}} contacts-page" data-test-contacts-page>
      <:header>
        <div class="navigation-bar" data-test-navigation-bar>
          <button
            class="button transparent back-button"
            type="button"
            data-test-contacts-page-back-button
            {{on "click" this.leaveContactPage}}
          >
            {{svgJar "messaging-chevron-left"}}
          </button>
          <h3 class="navigation-text" data-test-header>New message</h3>
        </div>
      </:header>
      <:default>
        {{#if this.messaging.getContacts.isRunning}}
          <div class="spinner" data-test-loading-spinner>
            {{svgJar "messaging-spinner"}}
          </div>
        {{else if this.messaging.contacts}}
          <ul class="contact-list-body" data-test-contact-list-body>
            {{#each this.messaging.contacts as |contact|}}
              <ContactListItem @contact={{contact}} />
            {{/each}}
          </ul>
        {{else}}
          <div class="empty-contact-list" data-test-empty-contact-list>
          </div>
        {{/if}}
      </:default>
    </MessagingPage>
  </template>
}
